const $ = require('jquery')
$(function () {
  const $calendar = $('#rental-calendar')
  $calendar.calendar({
    eventClassNames (arg) {
      if (arg.event.extendedProps.Type === 'OPTION') {
        return ['progress-bar-striped']
      }
      return []
    },
    eventClick ({ event, el }) {
      if (!event.extendedProps.ContractHeaderID && !event.extendedProps.InvoiceHeaderID) return
      if (event.extendedProps.ContractHeaderID) {
        const url = new URL($calendar.data('contractUrl'), location.protocol + '//' + location.host)
        url.hash = new URLSearchParams({ contract: event.extendedProps.ContractHeaderID }).toString()
        window.location.href = url.toString()
      } else if (event.extendedProps.InvoiceHeaderID) {
        const url = new URL($calendar.data('invoiceUrl'), location.protocol + '//' + location.host)
        url.hash = new URLSearchParams({ invoice: event.extendedProps.InvoiceHeaderID }).toString()
        window.location.href = url.toString()
      }
    }
  })
})
